/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: {},
	error: '',
};

const stayReasonsSlice = createSlice({
	name: 'stayReasons',
	initialState,
	reducers: {
		fetchStayReasons: state => {
			state.error = '';
		},

		fetchStayReasonsFulfilled: (state, { payload }) => {
			state.data = payload;
			state.error = '';
		},

		fetchStayReasonsFailed: (state, { payload: { error } }) => {
			state.data = [];
			state.error = error;
		},

		fetchStayReasonsCancel: () => {},
	},
});

export const {
	fetchStayReasons,
	fetchStayReasonsFulfilled,
	fetchStayReasonsFailed,
	fetchStayReasonsCancel,
} = stayReasonsSlice.actions;

export default stayReasonsSlice.reducer;
